<template>
  <label
    class="fieldset-checkbox-parts"
    :class="{ 'fieldset-checkbox-parts--validation-error': showError }"
  >
    <atom-input-checkbox
      class="fieldset-checkbox-parts__input"
      :error="showError"
      :isDisabled="isDisabled"
      :color="color"
      :value="checkValue"
      @input="onChecked"
    />
    <span class="fieldset-checkbox-parts__label">{{ label }}</span>
  </label>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import AtomInputCheckbox from '@/components/atoms/input/AtomInputCheckbox.vue'

/**
 * フィールドセット 汎用チェックボックス バーツ
 */
export default defineComponent({
  name: 'FieldsetCheckboxParts',
  components: {
    AtomInputCheckbox,
  },
  props: {
    /**
     * ラベルテキスト
     */
    label: {
      type: String,
      required: true,
    },
    /**
     * 入力データ
     */
    value: {
      type: Boolean,
      required: true,
    },
    /**
     * 必須フラグ
     */
    required: {
      type: Boolean,
      default: true,
    },
    /**
     * エラーフラグ
     */
    showError: {
      type: Boolean,
      default: false,
    },
    /**
     * 非活性にするかどうか
     */
    isDisabled: {
      type: Boolean,
      default: false,
    },
    /**
     * カラーパターン
     */
    color: {
      type: String,
      default: 'light',
    },
  },
  setup(props, context) {
    const checkValue = computed(() => props.value)
    const onChecked = (newValue: boolean) => context.emit('changed', newValue)

    return {
      checkValue,
      onChecked,
    }
  },
})
</script>

<style lang="scss" scoped>
.fieldset-checkbox-parts {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-items: flex-start;
  padding: 12px;
  gap: 12px;
  cursor: pointer;

  &__label {
    font-weight: 500;
    font-size: 12px;
  }
}
</style>
